import React from "react";
import { Link } from "react-router-dom";
import blacklogo from "../../images/blacklogo.svg";
import textlogo from "../../images/textlogo.svg";
import { company, socialLinks } from "../../content/companyProfile";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="vp-footer">
      <div className="vp-container">
        <div className="vp-footer__grid">
          <div className="vp-footer__brand">
            <div className="vp-footer__logos">
              <img src={blacklogo} alt="" aria-hidden />
              <img src={textlogo} alt={company.shortName} />
            </div>
            <p className="vp-footer__tagline">{company.tagline}</p>
            <p className="vp-footer__address">{company.address}</p>
          </div>

          <div className="vp-footer__col">
            <h4>Company</h4>
            <Link to="/#about">About</Link>
            <Link to="/services">Services</Link>
            {/* <Link to="/our-clients">Clients</Link> */}
            {/* <Link to="/resources">Resources</Link> */}
          </div>

          <div className="vp-footer__col">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-&-conditions">Terms & Conditions</Link>
            <Link to="/cancellation-&-refund">Cancellation & Refund</Link>
          </div>

          <div className="vp-footer__col">
            <h4>Contact</h4>
            <a href={`mailto:${company.email}`}>{company.email}</a>
            <a href={`tel:${company.phone.replace(/\s/g, "")}`}>{company.phone}</a>
            <Link to="/contact">Get in touch</Link>
            <Link to="/enquiry">Request a quote</Link>
          </div>
        </div>

        <div className="vp-footer__bottom">
          <p>
            © {year} {company.name}. All rights reserved.
          </p>
          <div className="vp-footer__socials">
            {socialLinks.map(({ label, icon, href }) => (
              <a key={label} href={href} aria-label={label} className="vp-footer__social">
                <i className={`fa-brands ${icon}`} aria-hidden />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
